var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
var Edit = function (props) { return (React.createElement("svg", __assign({ viewBox: "0 0 960 933.45", width: "1em", height: "1em" }, props),
    React.createElement("defs", null),
    React.createElement("g", { id: "Layer_2", "data-name": "Layer 2" },
        React.createElement("g", { id: "icon" },
            React.createElement("path", { className: "cls-1", d: "M258.29 537.56l-64 160a32 32 0 0 0 41.59 41.6l160-64a32 32 0 0 0 10.75-52.34l-96-96a32 32 0 0 0-52.34 10.74zm41.4 68.83l27.37 27.37L281.44 652zM950.63 78.82l-50.75-50.75a96.1 96.1 0 0 0-135.76 0L329.37 462.82a32 32 0 0 0 0 45.25l96 96a32 32 0 0 0 45.26 0l416-416a32 32 0 0 0-45.26-45.25L448 536.19l-50.75-50.74L809.37 73.33a32 32 0 0 1 45.26 0l50.74 50.74a32 32 0 1 0 45.26-45.25z" }),
            React.createElement("path", { className: "cls-1", d: "M832 325.45a32 32 0 0 0-32 32v416a96.11 96.11 0 0 1-96 96H160a96.11 96.11 0 0 1-96-96v-544a96.11 96.11 0 0 1 96-96h416a32 32 0 1 0 0-64H160c-88.22 0-160 71.77-160 160v544c0 88.22 71.78 160 160 160h544c88.22 0 160-71.78 160-160v-416a32 32 0 0 0-32-32z" }))))); };
export default Edit;
//# sourceMappingURL=Edit.js.map